export enum PROVIDERS {
    MELI = 'meli',
    SHOPIFY = 'shopify',
    TIENDA_NUBE = 'tiendanube',
}
